import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { OptionTypeBase, ValueType } from 'react-select';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { assignApplicationsWorkspace } from '../../../stores/applications/actionCreators';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { workspaceOptions } from '../../../stores/workspaces/selectors';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];
    workspaces: Array<{ label: string, value: string }>;

    assignApplicationsWorkspace: (ids: string[], workspaceId: string) => void;
}
interface State {
    showModal: boolean;
    workspace?: { label: string; value: string; };
}

class AssignApplicationsWorkspaceAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
            workspace: undefined
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['ASSIGN_APPLICATION_WORKSPACE', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="no-icon"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        {t('applications.button.assignWorkspace')}
                    </DropdownItem>
                    <ConfirmModal
                        className="overflow-visible"
                        header={t('applications.modal.assignWorkspace.header') as string}
                        confirmText={t('modal.assign') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            if (this.state.workspace) {
                                this.props.assignApplicationsWorkspace(
                                    this.props.selected,
                                    this.state.workspace.value,
                                );
                            }
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        <p>{t('applications.modal.assignWorkspace.text') as string}</p>
                        <Select className={"dropdown-select workspace-select"}
                            options={this.props.workspaces}
                            value={this.state.workspace}
                            onChange={this.handleSelectChange}
                        />
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private handleSelectChange = (val?: ValueType<{ label: string; value: string }>) => {
        // tslint:disable-next-line:no-any
        this.setState({ workspace: val as any });
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'applications'),
    workspaces: workspaceOptions(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    assignApplicationsWorkspace: (ids: string[], workspaceId: string) =>
        dispatch(assignApplicationsWorkspace(ids, workspaceId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(AssignApplicationsWorkspaceAction));